<template>
  <div class="selectTaskGroup">
    <!--<el-autocomplete
      ref="taskGroupAuto"
      popper-class="my-autocomplete"
      :size="size"
      :trigger-on-focus="true"
      clearable
      @clear="reset"
      @blur="groupBlur"
      @select="handleSelect"
      :fetch-suggestions="querySearchAsync"
      :style="{width: myWidth}"
      v-model="taskGroupName"
      placeholder="请选择任务分组"
      class="input-with-select"
    >
    <template slot-scope="{ item }">
      <div class="name">{{ item.NODENAME }}</div>
      <span class="addr">{{ item.NAMEPATH }}</span>
    </template>
    </el-autocomplete>-->

    <el-popover
      ref="popover"
      placement="bottom-start"
      trigger="click"
      class="select-tree scrollbar"
      @show="onShowPopover"
      @hide="onHidePopover">
      <div style="height:200px;">
        <el-scrollbar style="height: 100%;">
          <el-tree
            ref="tree"
            highlight-current
            :style="`width: ${treeWidth}`"
            :data="treeList"
            :props="defaultProps"
            :expand-on-click-node="false"
            :filter-node-method="filterNode"
            :default-expand-all="true"
            @node-click="handleSelect"
            @node-contextmenu="nodeContextmenu"
            >
          </el-tree>
        </el-scrollbar>
      </div>
      <el-input
        slot="reference"
        ref="input"
        v-model="taskGroupName"
        clearable
        @clear="reset"
        @blur="groupBlur"
        :style="`width: ${myWidth}px`"
        :class="{ 'rotate': showStatus }"
        :placeholder="'请选择任务分组'">
      </el-input>
    </el-popover>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="Rename">重命名</v-contextmenu-item>
      <v-contextmenu-item @click="Delete">删除</v-contextmenu-item>
    </v-contextmenu>

    <el-dialog
      title="选择任务分组"
      :visible.sync="dialogVisible"
      width="500px"
      :show-close="true"
      center
      append-to-body
    >
      <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <div style="height:280px;padding-top: 20px;" v-loading="loading">
        <el-scrollbar style="height: 100%;">
          <el-tree
            class="filter-tree"
            @node-click="nodeClick"
            :data="taskGroupList"
            :props="defaultProps"
            accordion
            node-key="Value"
            :filter-node-method="filterNode"
            highlight-current
            ref="taskGroup"
          ></el-tree>
        </el-scrollbar>
      </div>
      <div style="text-align: right;">
        <el-button @click="toClose">取 消</el-button>
        <el-button type="primary" @click="toSure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { GetAllTaskGroup } from "@/api/modules/basicData/task";
import { listToTree } from "@/api/modules/basicData/commonData";
import folderApi from "@/api/modules/basicData/folder";
import { mapState } from "vuex";
export default {
  data() {
    return {
      taskGroupName: "",
      dialogVisible: false,
      filterText: "",
      taskGroupList: [],
      loading: false,
      defaultProps: {
        id: "Value",
        children: "children",
        label: "Name"
      },
      defaultProps:{
        id: "RELATIONID",
        children: "children",
        label: "NODENAME"
      },
      NativeList: [],
      treeList:[],
      selectedGroup: null,
	    taskGroupInfo:{},

      // 树状菜单显示状态
      showStatus: false,
      // 菜单宽度
      treeWidth: 'auto',
      // 输入框显示值
      labelModel: '',
      // 实际请求传值
      valueModel: '0',
    };
  },
  watch: {
    filterText(val) {
      this.$refs.taskGroup.filter(val);
    },
    taskGroupName(val) {
      this.debouncedSearch(val);
      var list = this.taskGroupList.filter(a => {
        return a.NODENAME == val;
      });
      if (list.length) {
        this.selectedGroup = list[0];
        this.handleSelect(list[0]);
      }
    },
	  taskGroupInfo(row) {
      var list = this.NativeList.filter(a => {
        return a.NODENAME == row.NODENAME;
      });
      if (list.length) {
        this.selectedGroup = list[0];
        this.handleSelect(list[0]);
      }
    },
    taskGroup(val){
      this.initialValue();
    },
    labelModel(val) {
      if (!val) {
        this.valueModel = '';
      }
      this.$refs.tree.filter(val);
    },
    value(val) {
      this.labelModel = this.queryTree(this.data, val);
    },
    deep: true
  },
  props: {
    myWidth: {
      type: String,
      default: "250px"
    },
    size: {
      type: String,
      default: ""
    },
    taskGroup: {
      //默认任务组
      type: String,
      default: ""
    },
    PermissionType: {//0是个人 2是团队
      type: String,
      default: '团队'
    },
  },
  mounted() {
    this.GetAllTaskGroup();
    // this.initialValue();
  },
  computed: {
   ...mapState({
      Person: state => state.folder.Person
    })
  },
  methods: {
    Rename(){

    },
    Delete(){

    },
    nodeContextmenu(ev, data, node, val) {
        //右击
        const postition = {
          top: ev.pageY,
          left: ev.pageX
        };
        this.$refs.contextmenu.show(postition)
      },
    // 单击节点
    onClickNode(node) {
      this.labelModel = node[this.defaultProps.label];
      this.valueModel = node[this.defaultProps.value];
      this.onCloseTree();
    },
    // 隐藏树状菜单
    onCloseTree() {
      this.$refs.popover.showPopper = false;
    },
    // 显示时触发
    onShowPopover() {
      this.showStatus = true;
      this.$refs.tree.filter(false);
    },
    // 隐藏时触发
    onHidePopover() {
      this.showStatus = false;
      this.$emit('selected', this.valueModel);
    },
    // 树节点过滤方法
    filterNode(query, data) {
      if (!query) return true;
      return data[this.defaultProps.label].indexOf(query) !== -1;
    },
    // 搜索树状数据中的 ID
    queryTree(tree, id) {
      let stark = [];
      stark = stark.concat(tree);
      while (stark.length) {
        const temp = stark.shift();
        if (temp[this.defaultProps.children]) {
          stark = stark.concat(temp[this.defaultProps.children]);
        }
        if (temp[this.defaultProps.value] === id) {
          return temp[this.defaultProps.label];
        }
      }
      return '';
    },
    // tree 为当前树的数据源  key为父节点key值
    treeTransArray(tree) {
      var queen = [];
      var out = [];
      queen = queen.concat(tree);
      while(queen.length) {
          var first = queen.shift();
        if (first.children) {
          queen = queen.concat(first.children)
          // delete first['children'];
        }
        
        out.push(first);
      }
      return out;
    },
    initialValue() {
        let res = this.NativeList;
        console.log('GetAllTaskGroup',res)
        if (!res) return;
        const list = res.filter(item => {
          return (item.RELATIONID === this.taskGroup || item.NODEID===this.taskGroup);
        });
        setTimeout(() => {
          if (!list.length) {
            this.handleSelect(null);
          }
          else{
            this.handleSelect(list[0]);
          }
          // this.taskGroupName = list[0].NODENAME;
          // this.selectedGroup=list[0];
          // this.$emit("GetTaskGroup", list[0]);
        }, 500);
    },
    async GetMyTaskTreePath() {
      this.treeList = await folderApi.GetMyTaskTreePath(this.Person).then(res => {
         if(res){
          return res.find(item=>item.NODENAME==this.PermissionType).children;
         }esle
          return [];
      });
        // console.log('treeList1',this.treeList);
        this.NativeList = this.treeTransArray(this.treeList);
        // console.log('treeList',this.treeList);
        this.initialValue();
    },
    GetAllTaskGroup(){
      this.GetMyTaskTreePath();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.NODENAME.indexOf(value) !== -1;
    },
    reset() {
      // 置空数据
      console.log("reset");
      this.selectedGroup = null;
      this.taskGroupName = "";
      this.$emit("GetTaskGroup", null);
    },
    groupBlur() {
      console.info(this.selectedGroup, this.taskGroupName);
      if (
        !this.selectedGroup ||
        this.selectedGroup.NODENAME != this.taskGroupName
      ) {
        this.taskGroupName = "";
      }
    },
    openDialog() {
      // 打开弹窗
      this.dialogVisible = true;
      if (!this.taskGroupList.length) {
        this.GetAllTaskGroup();
      }
    },
    querySearchAsync(queryString, cb) {
      console.log('querySearchAsync',this.NativeList);
      var list = this.NativeList.filter(a => {
        return a.NODENAME.toLowerCase().indexOf(queryString.toLowerCase()) > -1;
      });
      list = list.map(a => {
        return Object.assign(a, { value: a.NODENAME });
      });
      cb(list);
    },
    getKeywordGroup(keyword) {
      if (keyword !== "") {
        setTimeout(() => {
          keyword = keyword.toLowerCase();
          let res = this.NativeList.filter(item => {
            return (
              item.NODENAME.toLowerCase().indexOf(keyword) > -1
            );
          });
          this.treeList = listToTree("VirtualId", "PvirtualId", res);
        }, 200);
      } else {
        this.treeList = listToTree("VirtualId", "PvirtualId", this.NativeList);
      }
    },
    nodeClick(data, node) {
      this.selectedGroup = data;
    },
    toClose() {
      this.dialogVisible = false;
    },
    handleSelect(item) {
      if (item) {
        this.selectedGroup = item;
        this.taskGroupName = item.NODENAME;
        this.valueModel = item[this.defaultProps.value];
        this.onCloseTree();
        this.$emit("GetTaskGroup", item);
      } else {
        this.selectedGroup = null;
        this.taskGroupName = "";
         this.valueModel="";
        this.$emit("GetTaskGroup", null);
      }
    },
    toSure() {
      if (this.selectedGroup) {
        this.taskGroupName = this.selectedGroup.NODENAME;
        this.$emit("GetTaskGroup", this.selectedGroup);
        this.dialogVisible = false;
      } else {
        this.$message.error("请选择一个任务分组!");
      }
    }
  },
  created(){
    this.debouncedSearch = _.debounce(this.getKeywordGroup, 1000);
  }
};
</script>

<style lang="less">
.selectTaskGroup .el-button {
  padding: 13px 12px;
}
.my-autocomplete {
  li {
    padding: 7px;
    line-height: normal;
    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .addr {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .addr {
      color: #ddd;
    }
  }
}
.scrollbar {
    overflow-y: scroll;
    &::-webkit-scrollbar {
      z-index: 11;
      width: 6px;
    }
    &::-webkit-scrollbar-track,
    &::-webkit-scrollbar-corner {
      background: #fff;
    }
    &::-webkit-scrollbar-thumb {
      // border-radius: 5px;
      width: 6px;
      background-color: #eee;
      &:hover {
        background-color: #ccc;
      }
    }
    &::-webkit-scrollbar-track-piece {
      background: #fff;
      width: 6px;
    }
  }
  .select-tree .el-input.el-input--suffix {
    cursor: pointer;
  }
  .select-tree .el-input.el-input--suffix.rotate .el-input__suffix {
    transform: rotate(180deg);
  }
</style>